export interface Category {
  slug: string;
  name: string;
  tagline: string;
  desc: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: "unsolved",
    name: "未解之谜",
    tagline: "卷宗未合，真相缺席",
    desc: "时间、地点、证人都写在纸上，唯独缺了最后一页答案。这里收着那些至今无人能完整解释的档案。",
    icon: "ri-question-line",
  },
  {
    slug: "paranormal",
    name: "灵异杂谈",
    tagline: "夜谈不必有结论",
    desc: "来自读者投稿与口述记录的深夜片段：老宅、旧楼、夜班走廊，以及那些解释不了的一两秒。",
    icon: "ri-moon-foggy-line",
  },
  {
    slug: "urban",
    name: "都市传说",
    tagline: "流传比真相更快",
    desc: "从校园宿舍到末班地铁，从裂口女到电梯游戏，追一条传说如何诞生、变形，最后住进每个人的记忆里。",
    icon: "ri-building-2-line",
  },
  {
    slug: "supernatural",
    name: "超自然现象",
    tagline: "边界之外的一手记录",
    desc: "睡眠瘫痪、集体幻视、无法归档的声学现象——把玄学拉回到记录、时间线与可能解释上。",
    icon: "ri-meteor-line",
  },
  {
    slug: "archive",
    name: "悬疑档案",
    tagline: "卷宗、现场与时间线",
    desc: "以纪实笔法重理旧案：现场痕迹、人物关系、调查节点，让悬案重新变得可读、可追踪。",
    icon: "ri-archive-2-line",
  },
  {
    slug: "darkweb",
    name: "暗网传闻",
    tagline: "传言与它的源头",
    desc: "红房间、数字幽灵、被删除的脸——我们不渲染恐惧，只把传闻的来路和证据链拆开给你看。",
    icon: "ri-signal-tower-line",
  },
];

export const getCategory = (slug: string): Category | undefined =>
  categories.find((item) => item.slug === slug);